<template>
  <div class="mobile act-lang">
    <div class="lang-btn"
      @click="toggleMobileLangList"
      @mouseenter="onPcHover"
      @mouseleave="onPcLeave"
    >
      {{ langMap[locale] }}
      <div class="lang-list" @click.stop v-show="showLangList">
        <div class="lang-item" v-for="item in langList" :key="item.value"
        @click="changeLang(item.value); $event.stopPropagation();">
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { computed, ref, onMounted, onUnmounted, defineProps } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import { langMap, supportedLangs } from '@/config/lang'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
const store = useStore()
const router = useRouter()
const route = useRoute()
const AccumRechargeDisableLang = ['in']
const { locale } = useI18n()
const showLangList = ref(false)
const isLangSelected = ref(false)

const langList = computed(() => {
  const langs = supportedLangs.map(lang => ({
    label: langMap[lang],
    value: lang
  }))
  if (route.name === 'AccumRecharge') {
    return langs.filter(lang => !AccumRechargeDisableLang.includes(lang.value))
  }
  return langs
})

// 切换语言列表显示/隐藏
const toggleMobileLangList = () => {
  if (isMobile) {
    showLangList.value = !showLangList.value
  }
}

// 切换语言
const changeLang = (lang) => {
  locale.value = lang
  store.commit('SET_LOCALE', lang)
  showLangList.value = false
  isLangSelected.value = true
  
  // 延迟重置状态，给用户足够时间移开鼠标
  setTimeout(() => {
    isLangSelected.value = false
  }, 500)
  
  // 更新当前路由的语言参数，而不是跳转到新页面
  const currentRoute = router.currentRoute.value
  if (currentRoute.params.locale !== lang) {
    router.push({ 
      name: currentRoute.name, 
      params: { ...currentRoute.params, locale: lang },
      query: currentRoute.query 
    })
  }
}

// 点击外部关闭下拉框
const closeDropdown = (e) => {
  if (!e.target.closest('.act-lang')) {
    showLangList.value = false
  }
}

// 在PC端鼠标悬停时显示语言列表
const onPcHover = () => {
  if (!isMobile) {
    showLangList.value = true
  }
}

const onPcLeave = () => {
  if (!isMobile) {
    showLangList.value = false
  }
}

// 添加点击事件监听
onMounted(() => {
  document.addEventListener('click', closeDropdown)
})

// 组件卸载时移除监听
onUnmounted(() => {
  document.removeEventListener('click', closeDropdown)
})
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
